import { Center } from "@mantine/core";
import { Outlet } from "react-router";

export function BasicLayout() {
  return (
    <Center mih="100vh" p="md">
      <Outlet />
    </Center>
  );
}
